import { CONSTRUCTION_ACTION_TYPE } from '../types';

const initialState = {};

const EMPTY_APPLICATION_STATE = {
  budget: null,
  drawRequests: [],
};

const getApplicationState = (state, applicationId) =>
  state[applicationId] || EMPTY_APPLICATION_STATE;

const replaceDrawRequest = (drawRequests, updated) => {
  if (!updated) {
    return drawRequests;
  }

  const index = drawRequests.findIndex(item => item.id === updated.id);

  if (index === -1) {
    return [...drawRequests, updated];
  }

  const next = [...drawRequests];
  next[index] = updated;

  return next;
};

const setApplicationSlice = (state, applicationId, slice) => ({
  ...state,
  [applicationId]: {
    ...getApplicationState(state, applicationId),
    ...slice,
  },
});

const constructionByApplicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONSTRUCTION_ACTION_TYPE.GET_BUDGET:
    case CONSTRUCTION_ACTION_TYPE.SAVE_BUDGET:
      return setApplicationSlice(state, action.meta.applicationId, {
        budget: action.payload || null,
      });

    case CONSTRUCTION_ACTION_TYPE.GET_DRAW_REQUESTS:
      return setApplicationSlice(state, action.meta.applicationId, {
        drawRequests: action.payload || [],
      });

    case CONSTRUCTION_ACTION_TYPE.CREATE_DRAW_REQUEST:

    case CONSTRUCTION_ACTION_TYPE.DECIDE_DRAW_REQUEST: {
      const { applicationId } = action.meta;
      const { drawRequests } = getApplicationState(state, applicationId);

      return setApplicationSlice(state, applicationId, {
        drawRequests: replaceDrawRequest(drawRequests, action.payload),
      });
    }

    case CONSTRUCTION_ACTION_TYPE.CLEAR: {
      const { applicationId } = action.meta ?? {};

      if (!applicationId) {
        return initialState;
      }

      const next = { ...state };
      delete next[applicationId];

      return next;
    }

    default:
      return state;
  }
};

export default constructionByApplicationReducer;
